export interface MessagePart {
  text: string
  highlighted: boolean
}

const HIGHLIGHT = /<span style="[^"]*">(.*?)<\/span>/gs

/**
 * Splits a localized message on its `<span style="…">…</span>` highlights
 * (one level, no nesting). The style value is copywriter notation such as
 * `#2AFD00`, not CSS, so the caller decides how a highlight looks. The
 * message is never parsed as HTML: everything outside a highlight stays
 * plain text.
 */
export function splitHighlights(message: string): MessagePart[] {
  const parts: MessagePart[] = []
  let end = 0
  for (const match of message.matchAll(HIGHLIGHT)) {
    if (match.index > end) {
      parts.push({ text: message.slice(end, match.index), highlighted: false })
    }
    parts.push({ text: match[1] ?? '', highlighted: true })
    end = match.index + match[0].length
  }
  if (end < message.length) {
    parts.push({ text: message.slice(end), highlighted: false })
  }
  return parts
}
